module.exports = __webpack_public_path__ + "static/media/get100.beb82032.png";